<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <aside>
      <div class="drawer-head"><strong>WishShop</strong><button class="close" @click="$emit('close')">Close</button></div>
      <nav>
        <template v-for="item in items"><a v-if="item.href" :key="item.label" :href="item.href" @click="$emit('close')">{{ item.label }}</a><router-link v-else :key="item.to + item.label" :to="item.to" @click.native="$emit('close')">{{ item.label }}</router-link></template>
      </nav>
      <section class="mobile-preferences">
        <div class="preference-line"><span>Language</span><PreferenceDropdown :value="language" aria-label="Mobile language" :options="languageOptions" @input="setLanguage" /></div>
        <div class="preference-line"><span>Currency</span><PreferenceDropdown :value="currency" aria-label="Mobile currency" :options="currencyOptions" @input="setCurrency" /></div>
      </section>
    </aside>
  </div>
</template>

<script>
import PreferenceDropdown from "./PreferenceDropdown.vue";

export default {
  components: { PreferenceDropdown },
  props: { open: Boolean, items: Array },
  computed: {
    language() { return this.$store.state.preferences.language; },
    currency() { return this.$store.state.preferences.currency; },
    currencies() { return this.$store.state.preferences.currencies; },
    languageOptions() {
      return [
        { value: "zh-CN", label: "简体中文", meta: "CN" }, { value: "en", label: "English", meta: "EN" },
        { value: "zh-TW", label: "繁體中文", meta: "TW" }, { value: "ja", label: "日本語", meta: "JA" },
        { value: "id", label: "Bahasa Indonesia", meta: "ID" }, { value: "vi", label: "Tiếng Việt", meta: "VI" },
        { value: "th", label: "ไทย", meta: "TH" },
      ];
    },
    currencyOptions() {
      const symbols = { USD: "$", EUR: String.fromCharCode(8364), GBP: String.fromCharCode(163), JPY: String.fromCharCode(165), AUD: "A$", CAD: "C$", SGD: "S$" };
      return this.currencies.map((item) => ({ value: item.code, label: item.code, meta: symbols[item.code] || item.symbol || item.sign || item.code }));
    },
  },
  methods: {
    setLanguage(value) { this.$store.commit("preferences/SET_LANG", value); },
    setCurrency(value) { this.$store.commit("preferences/SET_CURRENCY", value); },
  },
};
</script>

<style scoped>
.overlay { position:fixed; inset:0; background:#0008; z-index:70; }
.overlay aside { width:min(86vw,360px); height:100%; overflow-y:auto; background:#fff; padding:18px; }
.drawer-head { display:flex; min-height:48px; align-items:center; justify-content:space-between; border-bottom:1px solid var(--line); }
.drawer-head strong { font-size:22px; }
.close { border:0; background:none; padding:8px; color:var(--muted); }
nav { display:flex; flex-direction:column; padding:8px 0 16px; }
nav a { padding:12px 8px; border-bottom:1px solid var(--line); font-weight:600; }
.mobile-preferences { padding-top:12px; border-top:1px solid var(--line); }
.preference-line { display:flex; min-height:50px; align-items:center; justify-content:space-between; gap:14px; }
.preference-line > span { color:var(--muted); font-size:12px; font-weight:600; text-transform:uppercase; }
</style>
